import { Component, OnInit } from '@angular/core';
import { TipKomitenta } from './tip-komitenta';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-tip-komitenta',
  templateUrl: './tip-komitenta.component.html'
})
export class TipKomitentaComponent 
extends BaseModalContainer<TipKomitenta> 
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<TipKomitenta>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
